import { useQuery } from 'react-query'

import { subscriptionPriceService } from 'src/services/subscription-price.service'
import { QUERY_KEYS } from 'src/constants'
import { IOptionalSubscriptionPricesDto } from 'src/types'

export const useOptionalSubscriptionPrices = (params: IOptionalSubscriptionPricesDto) => {
  return useQuery(
    [QUERY_KEYS.SUBSCRIPTION_PRICES_OPTIONAL, params],
    () => subscriptionPriceService.getOptionalPrices(params),
    { keepPreviousData: true, refetchOnMount: false, refetchOnWindowFocus: false },
  )
}
